import { Controller } from "stimulus"

export default class extends Controller {
  static values = { source: String, syncAttributes: { type: Array, default: [ "value" ] } }

  connect() {
    this.sync()
    this.sourceElement.addEventListener("change", this.sync)
  }

  disconnect() {
    this.sourceElement.removeEventListener("change", this.sync)
  }

  sync = () => {
    if (!this.sourceElement) {
      return
    }

    if (this.sourceElement instanceof HTMLTextAreaElement) {
      this.syncTextarea()
    } else {
      this.syncGeneric()
    }
  }

  syncGeneric() {
    this.syncAttributesValue.forEach(attrib => {
      this.element[attrib] = this.sourceElement[attrib]
    })
  }

  syncTextarea() {
    this.syncAttributesValue.forEach(attrib => {
      this.element[attrib] = this.sourceElement[attrib].replace(/\s+/g, ' ')
    })
  }

  get sourceElement() {
    return document.querySelector(this.sourceValue)
  }
}
